<div class="styled-select {{ className }}" [ngClass]="{'has-value': selectedOption !== null}" [formGroup]="parentForm">
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="selectOption($event.option.value)">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
      {{ option.text }}
    </mat-option>
  </mat-autocomplete>
  <!-- Neutral border while typing but unselected is intentional — don't interrupt mid-search with an error state -->
  <input type="text" name="autocomplete-input" id="autocomplete-input" [placeholder]="placeholder" matInput [formControl]="input" [matAutocomplete]="auto" autocomplete="off"
         [class.confirmed-selection]="selectedOption !== null" [class.missing-required]="required && input.touched && !input.value">
  <a class="clear" (click)="onClear()"><i class="icon icon-cancel" aria-hidden="true"></i></a>
</div>
